export default "__VITE_ASSET__BFo8$B5O__"